import { Star } from "lucide-react";
import { CLINIC } from "../../data/content";
import { useTestimonials } from "../../hooks/useTestimonials";

export default function TestimonialsGrid({ limit = 6 }) {
  const testimonials = useTestimonials();
  if (!testimonials.length) return null;
  return (
    <section className="container-wide py-20">
      <div className="flex items-end justify-between mb-8">
        <div>
          <div className="eyebrow mb-3">Real patients, real recoveries</div>
          <h2 className="text-3xl md:text-5xl font-heading leading-[1.05]">Trusted by our community.</h2>
        </div>
        <div className="hidden md:flex items-center gap-1 text-sm text-brand-ink2">
          <Star className="fill-brand-amber text-brand-amber" size={16} /> {CLINIC.rating} · {CLINIC.reviewsCount} reviews
        </div>
      </div>
      <div className="grid md:grid-cols-3 gap-5">
        {testimonials.slice(0, limit).map((t) => (
          <TestimonialCard key={t.id} testimonial={t} />
        ))}
      </div>
    </section>
  );
}

function TestimonialCard({ testimonial: t }) {
  return (
    <div className="card-soft p-6" data-testid={`testimonial-${t.id}`}>
      <div className="flex gap-0.5 mb-3">
        {Array.from({ length: t.rating }, (_, i) => `${t.id}-s${i}`).map((k) => (
          <Star key={k} size={14} className="fill-brand-amber text-brand-amber" />
        ))}
      </div>
      <p className="text-brand-ink2 text-sm leading-relaxed">"{t.text}"</p>
      <div className="mt-4 text-sm">
        <span className="font-medium text-brand-ink">{t.name}</span>
        <span className="text-brand-ink2"> · {t.condition}</span>
      </div>
    </div>
  );
}
